<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">Unless otherwise noted, the images in this volume are from the collection of the Texas Prison Museum. Former employees and their families have donated photographs to the museum’s archive, providing an important resource for historians and history buffs alike. Other images were provided by the Texas Department of Criminal Justice (via the Texas Prison Museum), the Texas State Libraries and Archives, and the Thomason Room archive at Sam Houston State University.</p>
<p class="para">Special thanks go to Jim Willett, the director of the Texas Prison Museum, and Sandy Rogers, the museum’s registrar and archivist. They provided invaluable access to photographs in their collection and willingly shared their vast knowledge about the prison. Sandy graciously met me on her day off and even gave me a tour of Huntsville. I would also like to thank my husband, Tim, for listening to all of my “prison stories,” and my colleagues at Houston Community College-Northwest for their interest in this project.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?84a7153e